import { render } from "./collection-sub-navigation.vue?vue&type=template&id=09d89f3e"
import script from "./collection-sub-navigation.vue?vue&type=script&lang=js"
export * from "./collection-sub-navigation.vue?vue&type=script&lang=js"

import "./collection-sub-navigation.vue?vue&type=style&index=0&id=09d89f3e&lang=scss"

import exportComponent from "/Users/bornasepic/Desktop/projects/grau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__